var _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClose = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "15.54 7.05 12 10.59 8.46 7.05 7.05 8.46 10.59 12 7.05 15.54 8.46 16.95 12 13.41 15.54 16.95 16.95 15.54 13.41 12 16.95 8.46 15.54 7.05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.36cd03a1.svg";
export { ForwardRef as ReactComponent };